const BUSINESS_AREA_METADATA_UNAVAILABLE = "BUSINESS_AREA_METADATA_UNAVAILABLE";

export default function getSearchFieldsErrorMessage(result?: IResultState): string | undefined {
    if (!result || result.inProgress || result.success !== false) {
        return undefined;
    }

    if (result.code === BUSINESS_AREA_METADATA_UNAVAILABLE) {
        return "Unable to load your business areas. Please try again.";
    }

    return "Unable to load search fields. Please try again.";
}
